import React from 'react';
import {Link} from 'react-router-dom';
import {Card} from 'react-bootstrap';
import {Constants, ToolTipMessages} from '../../data/Constants'
import './style.css'
import HelperServices from '../../services/CommonServices';
import fail from '../../assets/images/red-cross-icon.svg';
import success from '../../assets/images/success-icon.svg';
import loading from '../../assets/images/processing-icon.svg';
import Table from 'react-bootstrap/Table';
import DropdownList from 'react-widgets/lib/DropdownList';
import ToggleTriangleButton from '../ViewTemplates/ToggleTriangleButton';
import Pagination from '../Pagination';
import Modal from 'react-bootstrap/Modal';
import DashboardIcon from '../../assets/images/dashboard-icon.png';
import Tooltip from '@material-ui/core/Tooltip'
import {logout} from "../../utils/authenticationUtils";

class ViewTemplates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            itemsBackup: [],
            currentPage: 1,
            showLoader: false,
            show: false,
            modalInfo: null,
            modalHeading: null,
            refreshView: false,
            defaultOption: Constants.All,
            options: [Constants.Alphabetical, Constants.lastModified],
            currentSortType: Constants.lastModified,
            successfulStatus: true,
            failedStatus: true,
            processingStatus: true,
            selected: false,
            searchedString: '',
            ascendingSort: true
        }
    }

    componentDidMount() {
        this.processing = false
        HelperServices.getTemplates().then((data) => {
            if (data.length > 0) {
                data.map(template => {
                    HelperServices.getTemplateImages(template.templateId, Constants.thumbnail)
                        .then((data) => {
                            const item = {id: '', name: '', src: ''}
                            item.id = template.templateId;
                            item.name = template.templateId;
                            item.status = template.status;
                            item.src = data;
                            item.selected = false;
                            var updateDatetime = new Date(template.updateDatetime)
                            item.updateDatetime = updateDatetime;
                            if (template.status === Constants.Processing) {
                                this.processing = true
                            }
                            this.setState({
                                items: this.state.items.concat([item]),
                                itemsBackup: this.state.itemsBackup.concat([item]),
                                currentSortType: 'Last modified'
                            });
                            this.filterDisplayItems()
                        }, error => {
                            const errorHtml = <div>
                                <i class='fad fa-ban dialog-error-icon'></i>
                                <h3>{Constants.headerUnauthorized}</h3>
                                <p>{Constants.unauthorizedMessage}</p>
                            </div>;
                            this._renderError(errorHtml);
                        })
                        .catch(() => {
                            console.log('There was some error while getting Templates images.')
                        })
                });
            }
        }).catch(() => logout())

        setInterval(this.refreshStatusOfCard, Constants.resendRequestTime)

        document.addEventListener('click', (event) => {
            let {items} = this.state
            let isSomethingSelected = items.find(x => x.selected === true)
            if (isSomethingSelected) {
                for (var i in items) {
                    items[i].selected = false
                }
                this.setState({
                    items,
                    selected: false
                })
            }
        })
    }

    _renderError = (error) => {
        this.setState({
            modalInfo: error
        })
        this.handleShow();
        this.setState({
            showLoader: false
        });
    }

    refreshStatusOfCard = () => {
        if (this.processing) {
            HelperServices.getTemplates()
                .then((templates) => {
                    let processingItems = this.state.itemsBackup.filter((template) => {
                        return template.status === Constants.Processing;
                    });
                    let {itemsBackup} = this.state
                    processingItems.map(processingTemplate => {
                        let objIndex = itemsBackup.findIndex((obj => obj.name === processingTemplate.name));
                        let templatesIndex = templates.findIndex((obj => obj.templateId === itemsBackup[objIndex].name));
                        if (templates[templatesIndex].status !== Constants.Processing) {
                            itemsBackup[objIndex].status = templates[templatesIndex].status
                        }
                    })
                    itemsBackup.map(obj => {
                        this.processing = obj.status === Constants.Processing;
                    })
                    this.setState({
                        itemsBackup,
                        items: itemsBackup
                    }, this.filterDisplayItems)
                })
                .catch(error => {
                    let errorMessage = ''
                    try {
                        errorMessage = error.data.message
                    } catch (error) {
                        errorMessage = Constants.generalErrorMessage
                    }
                    this.setState({
                        modalHeading: 'Error in fetching template(s)',
                        modalInfo: errorMessage
                    })
                    this.handleShow()
                })
        }
    }

    getSelectedItems(removeProcessing) {
        let selectedItem = []
        if (removeProcessing) {
            this.state.items.forEach(item => {
                if (item.selected && (item.status !== Constants.Processing)) {
                    selectedItem.push(item.name);
                }
            });
        } else {
            this.state.items.forEach(item => {
                if (item.selected) {
                    selectedItem.push(item.name);
                }
            });
        }

        return selectedItem;
    }

    downloadCard = () => {
        let selectedItems = this.getSelectedItems(true)
        if (selectedItems.length) {
            let downloadURL = process.env.REACT_APP_BACKEND_URL + Constants.downloadTaggingData;
            HelperServices.downloadTemplates(downloadURL, selectedItems)
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    let fileName = 'templates.zip'
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(error => {
                    let errorMessage = ''
                    try {
                        errorMessage = error.data.message
                    } catch (error) {
                        errorMessage = Constants.generalErrorMessage
                    }
                    this.setState({
                        modalHeading: Constants.headerDownloadError,
                        modalInfo: errorMessage
                    })
                    this.handleShow();
                })
        } else {
            this.setState({
                modalHeading: 'Download failed',
                modalInfo: 'Unable to download template'
            })
            this.handleShow();
        }
    }

    searchOnChange = event => {
        let searchedString = event.target.value
        this.setState({
            searchedString
        }, this.filterDisplayItems)
    }

    handleClose = () => {
        this.setState({show: false});
        if (this.state.refreshView) {
            window.location.reload();
            this.setState({
                refreshView: false
            })
        }
    }

    handleShow = () => this.setState({show: true});

    uploadTemplateStatus = (response) => {
        const rows = response['templates'].map(template => {
            return (
                <tr>
                    <td>{template.templateId}</td>
                    <td style={{width: '100px'}}
                        className={template.status === Constants.Successful ? 'successful' : 'failed'}>{template.status}</td>
                    <td>{template.message}</td>
                </tr>
            )
        })
        const modalInfo = (
            <Table striped bordered hover size="sm">
                <thead>
                <tr>
                    <th>Template ID</th>
                    <th style={{width: '100px'}}>Status</th>
                    <th>Description</th>
                </tr>
                </thead>
                <tbody className="text-break">
                {rows}
                </tbody>
            </Table>
        )
        this.setState({
            modalHeading: Constants.headerUploadStatus,
            modalInfo: modalInfo
        });
    }

    uploadTemplate = (event) => {
        this.setState({showLoader: true})
        const data = new FormData();
        data.append('zipFile', event.target.files[0])
        HelperServices.uploadTemplate(data)
            .then(response => {
                this.setState({
                    showLoader: false,
                    refreshView: true
                })
                this.uploadTemplateStatus(response.data)
                this.handleShow()
            })
            .catch(error => {
                let errorMessage = ''
                try {
                    errorMessage = error.data.message
                } catch (error) {
                    errorMessage = Constants.generalErrorMessage
                }
                this.setState({
                    modalHeading: Constants.headerUploadFailed,
                    modalInfo: errorMessage
                })
                this.handleShow()
                this.setState({
                    showLoader: false,
                    refreshView: true
                })
            })
    }

    deleteTemplate = (selectedItems) => {
        this.handleClose()
        this.setState({
            showLoader: true
        })
        HelperServices.deleteTemplate(selectedItems)
            .then(() => {
                const modalInfo = (
                    <div>
                        <span>{Constants.infoDeleteTemplate}</span>
                        <br/>
                        <div className="right-side">
                            <button className="btn btn-primary" onClick={() => {
                                this.handleClose()
                            }}>OK
                            </button>
                            &nbsp;&nbsp;&nbsp;

                        </div>
                    </div>
                )
                const items = this.state.items.filter(item => !selectedItems.includes(item.name));
                const itemsBackup = this.state.itemsBackup.filter(item => !selectedItems.includes(item.name));
                this.setState({
                    showLoader: false,
                    items,
                    itemsBackup,
                    modalHeading: Constants.headerDeleteTemplate,
                    modalInfo: modalInfo
                })
                this.handleShow();
            })
            .catch(error => {
                let errorMessage = ''
                try {
                    errorMessage = error.data.message
                } catch (error) {
                    errorMessage = Constants.generalErrorMessage
                }
                this.setState({
                    modalHeading: Constants.headerDeletionError,
                    modalInfo: errorMessage,
                    showLoader: false,
                })
                this.handleShow();
            })
    }

    deleteTemplateModal = (e) => {
        e.persist();
        e.nativeEvent.stopImmediatePropagation();
        const modalInfo = (
            <div>
                <span>{Constants.deleteConfirmation}</span>
                <br/>
                <br/>
                <div className="right-side">
                    <button className="btn button-global modal-ok" onClick={() => {
                        this.deleteBtnClick()
                    }}>OK
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button className="btn button-border-global modal-cancel" onClick={() => {
                        this.handleClose()
                    }}>Cancel
                    </button>
                    &nbsp;&nbsp;&nbsp;
                </div>
            </div>)
        this.setState({
            modalHeading: 'Delete Confirmation',
            modalInfo: modalInfo
        })
        this.handleShow();
    }

    deleteBtnClick = () => {
        let selectedItems = this.getSelectedItems(false)
        this.deleteTemplate(selectedItems)
    }

    getStatus = (status) => {
        if (status === Constants.Successful) {
            return <img src={success} className="footer-statusIcon" alt="success"/>
        } else if (status === Constants.Failed) {
            return <img src={fail} className="footer-statusIcon" alt="fail"/>

        } else if (status === Constants.Processing) {
            return <img src={loading} className="footer-statusIcon" alt="loading"/>
        }
    }

    successCheckboxChange = () => {
        this.setState({
            successfulStatus: !this.state.successfulStatus
        }, this.filterDisplayItems)
    }

    processingCheckboxChange = () => {
        this.setState({
            processingStatus: !this.state.processingStatus
        }, this.filterDisplayItems)
    }

    failedCheckboxChange = () => {
        this.setState({
            failedStatus: !this.state.failedStatus
        }, this.filterDisplayItems)
    }

    filterDisplayItems = () => {
        let failedItems = [];
        let successfulItems = [];
        let processingItems = [];
        if (this.state.failedStatus) {
            failedItems = this.state.itemsBackup.filter((item) => {
                return item.status === Constants.Failed;
            });
        }
        if (this.state.successfulStatus) {
            successfulItems = this.state.itemsBackup.filter((item) => {
                return item.status === Constants.Successful;
            });
        }
        if (this.state.processingStatus) {
            processingItems = this.state.itemsBackup.filter((item) => {
                return item.status === Constants.Processing;
            });
        }
        let finalList = [...failedItems, ...successfulItems, ...processingItems]
        let sortBy = this.state.currentSortType
        let items = finalList
        let sortByAscending = this.state.ascendingSort === true ? 1 : -1
        if (sortBy === 'Alphabetical') {
            items.sort(function (item1, item2) {
                const item1Name = item1.name.toUpperCase();
                const item2Name = item2.name.toUpperCase();
                if (item1Name < item2Name) {
                    return -1 * sortByAscending;
                }
                if (item1Name > item2Name) {
                    return 1 * sortByAscending;
                }
                return 0;
            });
        } else {
            items.sort((item1, item2) => {
                return (item2.updateDatetime - item1.updateDatetime) * sortByAscending;
            });
        }

        let {searchedString} = this.state
        if (searchedString.length) {
            items = items.filter((item) => item.name.toLowerCase().indexOf(searchedString.toLowerCase()) > -1);
        }
        this.setState({
            items,
            currentPage: 1
        })
    }

    onCardClick = (e, cardName) => {
        e.persist();
        e.nativeEvent.stopImmediatePropagation();
        let items = [...this.state.items]
        let selected
        if (e.ctrlKey) {
            for (var i in items) {
                if (items[i].name === cardName) {
                    items[i].selected = !items[i].selected;
                    break;
                }
            }
        } else {
            if (e.shiftKey) {
                let isSomethingSelected = items.find(x => x.selected === true)
                if (isSomethingSelected) {
                    let index1 = items.indexOf(isSomethingSelected);
                    let index2 = items.indexOf(items.find(x => x.name === cardName))
                    let firstName
                    let lastName
                    if (index1 < index2) {
                        firstName = isSomethingSelected.name
                        lastName = cardName
                    } else {
                        lastName = isSomethingSelected.name
                        firstName = cardName
                    }
                    let flagSelect = false;
                    for (var n in items) {

                        if (items[n].name === firstName) {
                            flagSelect = true
                        }
                        if (flagSelect) {
                            items[n].selected = true;
                        } else {
                            items[n].selected = false;
                        }
                        if (items[n].name === lastName) {
                            flagSelect = false
                        }
                    }
                } else {
                    for (var j in items) {
                        if (items[j].name === cardName) {
                            items[j].selected = !items[j].selected;
                            break;
                        }
                    }
                }
            } else {
                let isSomethingSelected = items.find(x => x.selected === true)
                for (var k in items) {
                    items[k].selected = false
                }
                if (isSomethingSelected) {
                    if (isSomethingSelected.name !== cardName) {
                        for (var l in items) {
                            if (items[l].name === cardName) {
                                items[l].selected = !items[l].selected;
                                break;
                            }
                        }
                    }
                } else {
                    for (var m in items) {
                        if (items[m].name === cardName) {
                            items[m].selected = !items[m].selected;
                            break;
                        }
                    }
                }
            }
        }

        selected = items.find(x => x.selected === true)

        this.setState({
            items,
            selected
        })
    }

    sortTypeChange = (value) => {
        this.setState({
            currentSortType: value
        }, this.filterDisplayItems)
    }

    isAscendingSort = (value) => {
        this.setState({
            ascendingSort: value
        }, this.filterDisplayItems)
    }

    handlePrevious = (currentPage) => {
        this.setState({currentPage})
    }

    handleNext = (currentPage) => {
        this.setState({currentPage})
    }

    render() {
        let allCards;
        const {items, currentPage} = this.state;
        const pageSize = Constants.pageSize
        const itemsToShow = items.slice((currentPage - 1) * pageSize, currentPage * pageSize);
        if (itemsToShow.length > 0) {
            allCards = itemsToShow.map((card, index) => {
                return (
                    <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 mb-4" key={card.name}>
                        <Card
                            className={`h-100 ${card.selected ? 'source-sans-pro card-selected template-card' : 'source-sans-pro template-card'}`}>
                            <Card.Body onClick={(e) => this.onCardClick(e, card.name)}>
                                <img variant="top" style={{width: '100%', height: '200px'}} alt='template card'
                                     src={card.src !== '' ? card.src : null}/>
                                <br/>
                                <b className="source-sans-pro pt-5" style={{textOverflow: 'ellipsis'}}>{card.name}</b>
                            </Card.Body>
                            <Card.Footer className="source-sans-pro template-card-footer">
                                {this.getStatus(card.status)}
                                <Tooltip title={ToolTipMessages.editTemplate}>
                                    <Link className="edit-template card-footer-cell"
                                          to={`/create-template/${card.id}`}/>
                                </Tooltip>
                            </Card.Footer>
                        </Card>
                    </div>
                );
            })
        }

        return (
            <div>
                {this.state.showLoader ?
                    <div className="loader-overlay-div">
                        <div className="app-loader"/>
                    </div>
                    : null}
                <div className="p-4 view-template-root-div">
                    <div className="container-fluid p-4">
                        <div className="row pb-4">
                            <div className="col">
                                <span className="row-padding heading-h1 montserrat align-middle">Templates</span>
                                <Link className="row-padding btn button-global source-sans-pro button-text-class"
                                      to="/upload-image">CREATE NEW TEMPLATE</Link>
                                <input type="file" accept=".zip" id="zip_uploader" name="zip_uploader"
                                       onChange={this.uploadTemplate} className="zip-uploader"/>
                                <label className="row-padding source-sans-pro button-text-class btn button-global mb-0"
                                       htmlFor="zip_uploader">UPLOAD EXISTING TEMPLATE</label>
                            </div>
                        </div>
                        <div className="row pb-4">
                            <div className="col">
                                <span className="page-heading nunito">
                                    <img src={DashboardIcon} alt='dashboard'
                                         style={{height: '40px', paddingBottom: '5px', marginRight: '20px'}}/>
                                    Dashboard
                                </span>
                            </div>
                        </div>
                        <div className="row pb-3 pl-2">
                            <div className="col checkbox-col">
                                <div className="row">
                                    <div className="col">
                                        <Tooltip
                                            title={this.state.selected ? ToolTipMessages.downloadTemplatesButtonActive : ToolTipMessages.downloadTemplatesButtonDisabled}>
                                            <span>
                                                <button
                                                    className={`source-sans-pro ${this.state.selected ? 'download-card' : ' download-card-disabled'}`}
                                                    onClick={this.downloadCard}/>
                                            </span>
                                        </Tooltip>
                                        <Tooltip
                                            title={this.state.selected ? ToolTipMessages.deleteTemplatesButtonActive : ToolTipMessages.deleteTemplatesButtonDisabled}>
                                            <span>
                                                <button
                                                    className={`source-sans-pro ${this.state.selected ? 'delete-icon' : 'delete-icon-disabled'}`}
                                                    onClick={this.deleteTemplateModal}/>
                                            </span>
                                        </Tooltip>
                                    </div>
                                    <div className="col">
                                        <div className="checkbox">
                                            <input style={{display: 'none'}} checked={this.state.successfulStatus}
                                                   onChange={this.successCheckboxChange} type="checkbox"
                                                   id="SuccessfulCheckbox" name="Successful"/>
                                            <label className="source-sans-pro" htmlFor="SuccessfulCheckbox"><p
                                                style={{paddingTop: '2px'}}>Successful</p></label>
                                            <img src={success} className="statusIcon" alt="success"/>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="checkbox">
                                            <input style={{display: 'none'}} checked={this.state.failedStatus}
                                                   onChange={this.failedCheckboxChange} type="checkbox"
                                                   id="FailedCheckbox" name="Failed"/>
                                            <label className="source-sans-pro" htmlFor="FailedCheckbox"><p
                                                style={{paddingTop: '2px'}}>Failed</p></label>
                                            <img src={fail} className="statusIcon" alt="success"/>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="checkbox">
                                            <input style={{display: 'none'}} checked={this.state.processingStatus}
                                                   onChange={this.processingCheckboxChange} type="checkbox"
                                                   id="ProcessingCheckbox" name="Processing"/>
                                            <label className="source-sans-pro" htmlFor="ProcessingCheckbox"><p
                                                style={{paddingTop: '2px'}}>Processing</p></label>
                                            <img src={loading} className="statusIcon" alt="success"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="search-sort-div">
                                    <DropdownList
                                        data={this.state.options}
                                        onChange={this.sortTypeChange}
                                        value={this.state.currentSortType}
                                        placeholder="Select an option"
                                        className="source-sans-pro dropdown-list pr-3"/>
                                    <ToggleTriangleButton size="9" onChange={this.isAscendingSort}/>
                                    <div className="pl-3" style={{display: 'inline-block', width: '100%'}}>
                                        <input className="form-control w-100 search-box source-sans-pro"
                                               type="text"
                                               placeholder={Constants.searchExistingTemplate}
                                               aria-label="Search"
                                               onChange={this.searchOnChange}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row pb-4">
                            <div className="col">
                                <div className="view-template-card">
                                    <div className="container-fluid pl-md-5 pt-4 pr-md-5 pb-5">
                                        <div className="row">

                                            {itemsToShow.length > 0 ? allCards :
                                                <div className="col">
                                                    <div className="source-sans-pro alert alert-info" role="alert">
                                                        Nothing to display
                                                    </div>

                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="right-side">
                                    <Pagination totalEntries={items.length} activePage={this.state.currentPage}
                                                pageSize={Constants.pageSize} handlePrevious={this.handlePrevious}
                                                handleNext={this.handleNext}/>
                                </div>
                            </div>
                        </div>

                        <Modal className="source-sans-pro modal-style text-justify" show={this.state.show}
                               onHide={this.handleClose}>
                            <Modal.Header closeButton>
                                <Modal.Title>{this.state.modalHeading}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="table-view">
                                <div>{this.state.modalInfo}</div>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>
        )
    }
}

export default ViewTemplates;
